import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Copy, Users, KeyRound } from "lucide-react";
import { api } from "@/lib/api";

export function SocietyInvite() {
  const [inv, setInv] = useState(null);
  useEffect(() => { api.get("/society/invite").then(({ data }) => setInv(data)).catch(() => {}); }, []);
  if (!inv?.eligible) return null;
  const copy = () => navigator.clipboard.writeText(inv.link).then(() => toast.success("Invite link copied")).catch(() => toast.error("Copy blocked by the browser"));
  return (
    <div data-testid="society-invite" className="max-w-3xl mx-auto mb-10 rounded-3xl border border-gold/30 bg-surface p-7">
      <p className="text-[10px] uppercase tracking-[0.3em] text-gold flex items-center gap-2"><KeyRound size={13} /> Your society invite</p>
      <p className="font-display text-2xl font-light mt-3">Give friends a week of Premium</p>
      <p className="text-sm text-text-muted mt-1">Friends who join with your link get {inv.days} days of Premium once they start Basic. Invite as many as you like.</p>
      <div className="mt-5 flex flex-wrap items-center gap-3">
        <span data-testid="society-invite-code" className="font-mono text-lg tracking-[0.2em] text-gold border border-gold/40 rounded-full px-5 py-2">{inv.code}</span>
        <button data-testid="society-invite-copy" onClick={copy} className="flex items-center gap-2 px-5 py-2.5 rounded-full bg-gold text-ink text-[10px] uppercase tracking-[0.18em]"><Copy size={13} /> Copy invite link</button>
      </div>
      <code data-testid="society-invite-link" className="block mt-3 text-[11px] text-text-muted break-all">{inv.link}</code>
      <p data-testid="society-invite-stats" className="mt-4 text-xs text-text-muted flex items-center gap-2"><Users size={13} className="text-gold" /> {inv.joined} joined · {inv.activated} unlocked their week</p>
    </div>
  );
}
